import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import webFormPageActions from '../actions/webFormPage';
import actions from '../actions/actions';

// responds to 'GET_LEAD_FORM_DETAILS' action
function getWebformMetadata(store) {
    request.get(`/${config.webFormPrefix}/api/getWebformMetadata`)
        .end((error, response) => {
            if (error) {
                store.dispatch(webFormPageActions.alertError('internal.server.error'));
            } else {
                try {
                    const parsedResponse = JSON.parse(response.text);
                    if (!parsedResponse || parsedResponse.code >= 400) {
                        store.dispatch(webFormPageActions.alertError('ipmob.error.process.request'));
                    } else {
                        const defaultLocale = store.getState().system.locale;
                        store.dispatch(webFormPageActions.getWebformMetadataSuccess(parsedResponse, defaultLocale));
                    }
                } catch (exp) {
                    store.dispatch(webFormPageActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}
export default getWebformMetadata;
